module.exports = {"id":"208965","name":"Ahmed Hassan Asiri","rating":"71","photo":"./data/images/photos/0/208965.png","club":{"name":"Al Ittihad","logo":"./data/images/clubs/AlIttihad.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AhmedHassanAsiri0.json
// module id = 130
// module chunks = 0